exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.examTimer {\n  position: fixed;\n  left: 0px;\n  top: 100px;\n}\n.list-group-item {\n  background-color: transparent !important;\n  border-top: 1px solid #ddd !important;\n  border-left: transparent !important;\n  border-right: transparent !important;\n  border-radius: 0 !important;\n}\n@media print {\n#finish-modal {\n     display: none;\n}\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-bf3f6cba","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exercises/ExamExercise.vue
// module id = 961
// module chunks = 1